import React from 'react';
import FavouriteBtn from '../../atoms/FavouriteBtn/FavouriteBtn';
import LazyPicture from '../../atoms/LazyPicture';
import RouterLink from '../../atoms/RouterLink';
import Reminder from '../../atoms/Reminder/Reminder';
import CuratorPicks from '../../atoms/CuratorPicks/CuratorPicks';
import { convertDate } from '../Events';
import ScrollAnimation from 'react-animate-on-scroll';
import { pathJoin, getMediaHost, injectImageResolution, get, getListingItemURL } from '../../../utils';
import { tealiumClickFunc, tealiumMergeClickData } from '../../../utils/tealium';
import { BlurCard, EBlurCardImageTypes, isShowRuleIsHide } from '../../atoms/BlurCard/BlurCard';
const FeaturedEventBlock = _ref => {
  let {
    event,
    curatorsCopy,
    lang,
    analytics,
    hostLink,
    multipleDates,
    countryItems,
    themeValues,
    isListing = false,
    userProfile
  } = _ref;
  const firstEvents = event;
  const {
    eventsAnalytics,
    params
  } = analytics;
  const firstImage = get(firstEvents, 'image');
  const curators = get(firstEvents, 'curators.curators');
  const imgSrc = injectImageResolution(`${pathJoin([getMediaHost(), firstImage])}`, 700, 428);
  const imgSrcMob = injectImageResolution(`${pathJoin([getMediaHost(), firstImage])}`, 460, 460);
  const firstImageAlt = get(firstEvents, 'title');
  const eventIsBusiness = get(event, 'eventIsBusiness');

  // const videoSrc = 'https://www.visitdubai.com/-/media/dctcm/campaigns/2019/h/hollywood-campaign/video/v4/1600_450.mp4';

  return /*#__PURE__*/React.createElement(React.Fragment, null, isShowRuleIsHide(event) ? /*#__PURE__*/React.createElement("div", {
    className: "events__item"
  }, /*#__PURE__*/React.createElement(BlurCard, {
    userProfile: userProfile,
    hint: event,
    lang: lang,
    cardType: EBlurCardImageTypes.event,
    hitAnalytics: eventsAnalytics,
    hitParams: params,
    reminderTheme: themeValues,
    countryItems: countryItems,
    showWithAnimation: true
  })) : /*#__PURE__*/React.createElement("div", {
    className: "events__featured-item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "event-row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-5 col-lg-5 col-xl-6 events__featured-image-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "events__featured-image-wrap"
  }, firstImage && /*#__PURE__*/React.createElement(RouterLink, {
    openInSameTab: true,
    href: getListingItemURL(hostLink, firstEvents.urlSlug, firstEvents.url),
    onClick: () => tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['bannerClickAnalytics'], params), event.englishTitle),
    title: firstImageAlt
  }, /*#__PURE__*/React.createElement(LazyPicture, {
    useEmptyPlaceholder: true,
    hover: true
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 480px)",
    srcSet: imgSrc
  }), /*#__PURE__*/React.createElement("img", {
    className: "events__featured-image",
    src: imgSrcMob,
    alt: firstImageAlt
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "col-xl-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-md-6 col-lg-6 col-xl-5 events__featured-info-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "events__info"
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.15
  }, /*#__PURE__*/React.createElement(CuratorPicks, {
    curators: curators,
    copy: curatorsCopy,
    analytics: {
      eventsAnalytics,
      params,
      name: event.englishTitle
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "events__text-sight"
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.3
  }, firstEvents && firstEvents.category && firstEvents.category.join(' '))), /*#__PURE__*/React.createElement("a", {
    className: "events__item-title",
    href: getListingItemURL(hostLink, firstEvents.urlSlug, firstEvents.url),
    onClick: () => tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['titleClickAnalytics'], params), event.englishTitle)
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.45
  }, firstEvents.title)), /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.6
  }, /*#__PURE__*/React.createElement("p", {
    className: "body-small events__text"
  }, firstEvents.introText, " ")), /*#__PURE__*/React.createElement("div", {
    className: "events__featured-fav-wrapper"
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.7
  }, /*#__PURE__*/React.createElement("div", {
    className: "events__date-item"
  }, firstEvents.eventNextAvailableDate ? `${multipleDates} ${convertDate(firstEvents.eventNextAvailableDate, '', lang)}` : firstEvents.datesRange && convertDate(firstEvents.datesRange.from_formatted, firstEvents.datesRange.from_formatted === firstEvents.datesRange.to_formatted ? '' : firstEvents.datesRange.to_formatted, lang))), /*#__PURE__*/React.createElement(FavouriteBtn, {
    itemId: firstEvents && firstEvents.objectID,
    classes: 'events__fav-btn',
    componentPrimaryColor: 'var(--events-theme-background-color)',
    componentPrimaryColorActive: "var(--events-theme-background-active-color)",
    analyticsClick: eventTitle => tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['addToFavAnalytics'], params), `${eventTitle}: ${event.englishTitle}`),
    isListing: isListing
  })), /*#__PURE__*/React.createElement("div", {
    className: "events__push-bottom"
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.8
  }, !eventIsBusiness && /*#__PURE__*/React.createElement(Reminder, {
    userProfile: userProfile,
    lang: lang,
    event: event,
    countryItems: countryItems,
    themeValues: themeValues,
    modeFeatured: true,
    eventsAnalytics: eventsAnalytics,
    params: params
  }))))))));
};
export default FeaturedEventBlock;